import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
// -*- mode: jsx;-*-
import { HomeProjectSection } from './HomeProjectSection.js';
import { shuffleAndTruncate } from './arrayUtils.js';
import { convertToApiURL } from './searchRequestUtils.js';


export const ProjectSearchController = createReactClass({

    propTypes: {
        suggestedProjectsSearchURL: PropTypes.string.isRequired,
        showGiveWidget: PropTypes.bool,
        giveWidgetSubmitTakesUserDirectlyToCart: PropTypes.bool,
        description: PropTypes.string,
        seeMoreText: PropTypes.string,
        className: PropTypes.string,
    },

    getDefaultProps: function () {
        return {
            showGiveWidget: false,
            giveWidgetSubmitTakesUserDirectlyToCart: false,
            description: 'HERE ARE SOME OTHER PROJECTS YOU MIGHT LIKE',
            seeMoreText: 'See more classroom projects',
            className: 'projects-most-urgent',
        };
    },

    getInitialState: function () {
        return {
            projectData: null,
        };
    },

    getProjects: function () {
        return this.state.projectData;
    },

    loadProjects: function () {
        var url = this.props.suggestedProjectsSearchURL;
        if (this.state.projectData && this.state.projectData.length > 0) {
            // Already loaded
            return;
        }

        $.ajax({
            type: 'get',
            url: convertToApiURL(url),
            cache: true,
            dataType: 'json',
            success: this.handleProjectResponse,
            error: (xhr, status, message) => {
                // It seems like we can get false positives of parsererror
                if (status !== 'parsererror') {
                    this.addProjectData(url, []);
                }
            },
        });
    },

    handleProjectResponse: function (data) {
        this.addProjectData(data.searchURL, data.proposals);
    },

    /**
     * Updates the component's state with project data
     * @param {string} url The search URL for the projects
     * @param {object[]} data The list of project data
     */
    addProjectData: function (url, data) {
        // this is a bit of a hack. don't shuffle if showing an existing donor projects they recently
        // donated to. those are sorted by expiration date, to highlight those soonest to expire.
        var projectData = url.indexOf('id=') > -1 ? data : shuffleAndTruncate(data, 3);

        this.setState({
            projectData: projectData,
        });
    },

    render: function () {
        var props = this.props;

        return (
            <div className="article-project-list">
                <section className="projects">
                    <div className="container">
                        <HomeProjectSection
                            searchURL={props.suggestedProjectsSearchURL}
                            description={props.description}
                            seeMoreText={props.seeMoreText}
                            loadProjects={this.loadProjects}
                            className={props.className}
                            projects={this.state.projectData}
                            showGiveWidget={props.showGiveWidget}
                            giveWidgetSubmitTakesUserDirectlyToCart={props.giveWidgetSubmitTakesUserDirectlyToCart}
                        />
                    </div>
                </section>
            </div>
        );
    },

});
